export default {
	name: 'textarea-counter',
	computed: {
		charactersLeft() {
			return `${ (this.limit - this.size) } / ${ this.limit }`;
		}
	},
	props: {
		size: {
			type: Number,
			required: true
		},
		limit: {
			type: Number,
			default: 1000
		}
	}
};



// WEBPACK FOOTER //
// ./sources/components/textarea-counter/index.js